export interface ILocationMySuffix {
    id?: number;
    adress?: string;
    latitude?: number;
    longitude?: number;
    countryISO?: string;
    countryName?: string;
    placeId?:string;
    coverStartDate?:string;
    coverEndDate?: string;
    addressState?: string;

}

export class LocationMySuffix implements ILocationMySuffix {
    constructor(
        public id?: number,
        public adress?: string,
        public latitude?: number,
        public longitude?: number,
        public countryISO?: string,
        public countryName?: string,
        public placeId?:string,
        public coverStartDate?: string,
        public coverEndDate?: string,
        public addressState?: string
    

    ) { }

}
